import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={4}
    height={280}
    fill="none"
    {...props}
  >
    <path
      stroke="url(#aya)"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M2 14v231"
    />
    <path fill="url(#bya)" d="M0 0h4v4H0z" />
    <path fill="url(#cya)" d="M0 256h4v4H0z" />
    <path fill="url(#dya)" d="M0 266h4v4H0z" />
    <path fill="url(#eya)" d="M0 276h4v4H0z" />
    <defs>
      <linearGradient
        id="aya"
        x1={2.544}
        x2={2.544}
        y1={-242.376}
        y2={402.002}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DDCFA2" />
        <stop offset={0.095} stopColor="#8C866B" />
        <stop offset={0.24} stopColor="#8C866A" />
        <stop offset={0.475} stopColor="#F5E6B6" />
        <stop offset={0.62} stopColor="#8C866B" />
        <stop offset={0.86} stopColor="#8C866B" />
        <stop offset={1} stopColor="#A59A87" />
      </linearGradient>
      <linearGradient
        id="bya"
        x1={2}
        x2={2}
        y1={0}
        y2={4}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9B8876" />
        <stop offset={1} stopColor="#AEA373" />
      </linearGradient>
      <linearGradient
        id="cya"
        x1={2}
        x2={2}
        y1={256}
        y2={260}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9B8876" />
        <stop offset={1} stopColor="#AEA373" />
      </linearGradient>
      <linearGradient
        id="dya"
        x1={2}
        x2={2}
        y1={266}
        y2={270}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9B8876" />
        <stop offset={1} stopColor="#AEA373" />
      </linearGradient>
      <linearGradient
        id="eya"
        x1={2}
        x2={2}
        y1={276}
        y2={280}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9B8876" />
        <stop offset={1} stopColor="#AEA373" />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgComponent
